import { render, staticRenderFns } from "./AnswersHeader.vue?vue&type=template&id=92170eac&scoped=true&"
import script from "./AnswersHeader.vue?vue&type=script&lang=js&"
export * from "./AnswersHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92170eac",
  null
  
)

export default component.exports